import Modal, { Nav } from 'components/Modal'
import ZeroCard from 'components/ZeroCard'
import React, { useState } from 'react'
import * as CategoryModule from 'modules/category';
import * as DocumentModule from 'modules/document';
import classes from "./ZeroLicenses.module.scss"
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import Type from 'components/Type';
import * as Icon from 'components/Icon';
import DocumentView from 'modules/category/containers/View/DocumentView';
import { useDispatch } from 'react-redux';


const ZeroLicenses = () => {
  const [isModel, setModal] = useState(false)
  return (
    <>
      <ZeroCard onClick={() => setModal(true)} />
      <Modal isOpen={isModel} close={() => setModal(false)}>
        <Nav showClose onClose={() => setModal(false)} />
        <ZeroModal />
      </Modal>
    </>
  )
}

const ZeroModal = () => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation()
  const { entitiesZero } = DocumentModule.Hooks.useList()
  const { state, methods } = CategoryModule.Context.Single.useContext();

  const onSelect = (id: number) => {
    dispatch(DocumentModule.Actions.Info.request({
      documentId: id,
      callback: {
        onSuccess(data) {
          const categoryId = get(data, 'info.category.parent_id')
          const subCategoryId = get(data, 'info.category.id')
          methods.setDocument(id, categoryId, subCategoryId)
        },
      }
    }))
  }

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.wrapperHeader}>
          <h1 className={classes.wrapperTitle}>{t('start_business_without_any_lisenses')}</h1>
        </div>
        <div className={classes.list}>
          {entitiesZero.map(item => (
            <div key={item.id} className={classes.listItem} onClick={() => onSelect(item.id)}>
              <div className={classes.listItemTitle}>{get(item, `title[${i18n.language}]`)}</div>
              <div className={classes.listItemType}>
                <Type variant="blue">{get(item, `type.title[${i18n.language}]`)}</Type>
              </div>
              <div className={classes.listItemIcon}>
                <Icon.System.Right />
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal isOpen={!!state.isVisible} close={methods.setClose}>
        <DocumentView />
      </Modal>
    </>
  )
}

export default ZeroLicenses